/**
 * Analytics IDs — central config.
 * Replace the placeholders below with your real IDs.
 *
 *  - GA4_MEASUREMENT_ID:  Analytics → Admin → Data streams (format: G-XXXXXXXXXX)
 *  - GTM_CONTAINER_ID:    Tag Manager workspace (format: GTM-XXXXXXX)
 *  - GOOGLE_ADS_ID:       Existing Google Ads conversion tag (already live).
 *
 * Leave a value empty ("") to disable that integration entirely.
 */
export const GA4_MEASUREMENT_ID = ""; // e.g. "G-XXXXXXXXXX"
export const GTM_CONTAINER_ID = ""; // e.g. "GTM-XXXXXXX"
export const GOOGLE_ADS_ID = "AW-18513975722";
/** Conversion "Zakazivanje / kontakt" (BOOK_APPOINTMENT) — fired on phone/WhatsApp/form success. */
export const GOOGLE_ADS_CONVERSION_SEND_TO = "AW-18513975722/y_1SCLmWpZ0dEKqzk_xE";
